import { Fragment } from 'react'

import { FormRow, Label, Radio, RadioGroup } from 'basic-components'
import { DataScienceEnums } from 'dashboard-services/api/dataScience'

import ParamValue from '../ParamValue'

import { When } from 'react-if'

const { DATALAKE_FILE } = DataScienceEnums.TASK_PARAM_VALUE_TYPE
const FILE_ID_PARAM = "${fileId}"

const TaskParam = ({ getAllParams, menuPortalTarget, onChangeParamValue, paramDef, paramName, paramValue, taskName }) => {
  const isDatalakeFile = paramDef?.valueType === DATALAKE_FILE,
        shouldShowValue = (paramDef !== undefined && !isDatalakeFile) || (isDatalakeFile && paramValue !== FILE_ID_PARAM && paramValue !== "")

  return (
    <Fragment>
      <When condition={isDatalakeFile}>
        {() => (
          <FormRow className="data-lake__group-dialog__advanced__dynamic-validation__row data-lake__group-dialog__advanced__dynamic-validation__row--with-indent">
            <Label
                noError
                required={!paramDef?.optional}
            >
              {paramDef.readableName || paramDef.name}
            </Label>
            <RadioGroup
                name="paramValue"
                onChange={value => onChangeParamValue(value, paramName)}
                selectedValue={paramValue !== FILE_ID_PARAM ? paramValue : FILE_ID_PARAM}
            >
              <Radio name={FILE_ID_PARAM}>Use uploaded file</Radio>
              <Radio name=" ">Choose file</Radio>
            </RadioGroup>
          </FormRow>
        )}
      </When>
      <When condition={shouldShowValue}>
        {() => (
          <ParamValue
              getAllParams={getAllParams}
              menuPortalTarget={menuPortalTarget}
              onChangeParamValue={onChangeParamValue}
              paramDef={paramDef}
              paramName={paramName}
              paramValue={paramValue}
              taskName={taskName}
          />
        )}
      </When>
    </Fragment>
  )
}

TaskParam.propTypes = ParamValue.propTypes

export default TaskParam
